import { createFileRoute } from "@tanstack/react-router"
import BudgetDetailView from "~/components/budget/BudgetDetailView"
import { WorkspacePage } from "~/components/design-system/pages"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target")(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  return (
    <WorkspacePage contentClassName="p-0">
      <BudgetDetailView />
    </WorkspacePage>
  )
}
